import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

type FileFormatType = 'xlsx' | 'pdf';
interface IProps {
  action?: string;
  locations?: Array<number>;
  period?: string;
  withInstPointData?: number;
  withWatchList?: string;
  aiType?: string;
  checkboxValue?: boolean;
  customerId?: string;
  fileFormat?: FileFormatType;
}

interface IReportAction {
  [key: string]: {
    url: string;
    params: object;
    extraParams?: object;
  };
}

const reportActionsFn = ({
  action,
  locations,
  period,
  withInstPointData,
  withWatchList,
  aiType,
  checkboxValue,
  customerId,
  fileFormat,
}: IProps) => {
  const reportActions: IReportAction = {
    exportActionListReports: {
      url: `${APP_API_URL}action-list-reports`,
      params: { location_ids: locations, customer_id: customerId, type: fileFormat, period },
      extraParams: {
        responseType: 'arraybuffer',
      },
    },
    exportEquipmentFailureReport: {
      url: `${APP_API_URL_V2}fsd/action-item/report/repeat-trends/export`,
      params: { location_ids: locations, period, ai_type: aiType },
      extraParams: {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/octet-stream',
        },
      },
    },
    exportEquipmentReport: {
      url: `${APP_API_URL}equipments/export-by-structure-v2`,
      params: { locations, with_installation_point_data: withInstPointData },
    },
    exportActiveActionItems: {
      url: `${APP_API_URL_V2}fsd/action-item/report/active-action-items/export`,
      params: {
        selected_location_id: locations,
        period,
        with_watchlist: withWatchList,
        type: aiType,
        includeClosed: checkboxValue,
      },
      extraParams: {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/octet-stream',
        },
      },
    },
    exportCostSavings: {
      url: `${APP_API_URL_V2}fsd/action-item/report/cost-savings/export`,
      params: { location_ids: locations, period, exclude_items_with_zero_savings: +!checkboxValue },
      extraParams: {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/octet-stream',
        },
      },
    },
    exportPercentage: {
      url: `${APP_API_URL}export-alert-counts`,
      params: { location_id: locations, period, is_persentage: true },
    },
    hardwareOverview: {
      url: `${APP_API_URL_V2}customer-dashboard-v2/hardware-overview/export`,
      params: { location_ids: locations },
      extraParams: {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/octet-stream',
        },
      },
    },
    userList: {
      url: `${APP_SSO_URL}api/user/export-users-v2`,
      params: {
        filter: {
          locationId: locations,
          permission: ['dashboardAccess', 'readonlyAccess'],
          excludeCurrentUser: 0,
          withoutWaitesUsers: 1,
        },
      },
    },
  };

  const { url, params, extraParams } = reportActions[action as keyof typeof reportActions];

  return apiClient.get(url, {
    params,
    ...(extraParams || {}),
  });
};

export const useReportActionsMutation = () => {
  return useMutation({
    mutationFn: reportActionsFn,
  });
};
